module.exports = __webpack_public_path__ + "img/comment-question.00619371.svg";